import React from 'react';
import __ from 'lodash';

class DropdownTahunAjaran extends React.Component{
    render(){           
        return (
            this.props.tahunAjaran.map((val) =>
                <option key={val.kodeTahunAjaran} value={val.kodeTahunAjaran} selected={val.status =="1" ? "seleted" : ""}>{val.kodeTahunAjaran}</option>
                // <option key={val.kodeTahunAjaran} value={val.kodeTahunAjaran} >{val.kodeTahunAjaran}</option>
            )            
        )
    }
}

export default DropdownTahunAjaran;